export const inputTypes = {
  text: 'TEXT',
  email: 'EMAIL',
  date: 'DATE',
  dateRange: 'DATE_RANGE',
  dropdown: 'DROPDOWN',
  checkbox: 'CHECKBOX',
  currency: 'CURRENCY',
  expiration: 'EXPIRATION',
  list: 'LIST',
  color: 'COLOR',
  cvv: 'CVV',
  file: 'FILE',
  masked: 'MASKED',
  name: 'NAME',
  number: 'NUMBER',
  password: 'PASSWORD',
  picker: 'PICKER',
  phone: 'PHONE',
  radio: 'RADIO',
  routingNumber: 'ROUTING_NUMBER',
  ssn: 'SSN',
  time: 'TIME',
  timeRange: 'TIME_RANGE',
  zip: 'ZIP',
  postalAddress: 'POSTAL_ADDRESS'
};